export default "__VITE_ASSET__CkHE$kC4__"